module.exports = __webpack_public_path__ + "img/Guide.0a35d794.svg";